<template>
  <footer class="footer">
    <div class="footer_top">
      <div class="footer_left">
        <img src="../../assets/cloud_logo_white.svg" alt="logo">
        <p class="footer_left_p">天识科技有限公司</p>
        <div class="footer_left_div">杭州天识信息网络科技有限公司总部位于中国杭州，在深圳，美国，设有分部，业务覆盖欧洲，澳洲，亚洲和美国等195个国家及地区 。天识自2019年开始为中国卖家提供全球开店、卖家孵化、系统支持、供应链、等综合服务。累计服务5万家跨境企业，成功孵化20万+跨境电商创业者。</div>
      </div>
      <div class="footer_middle">
        <div class="footer_line"></div>
        <div class="footer_middle_top">
          <span class="footer_middle_top_span" @click="golink('home')">首页</span>
          <div class="footer_middle_top_div"></div>
          <span class="footer_middle_top_span" @click="golink('product')">产品功能</span>
          <div class="footer_middle_top_div"></div>
          <span class="footer_middle_top_span" @click="golink('help')">帮助中心</span>
        </div>
        <div class="footer_middle_center" v-if="ispc">
          <div class="footer_middle_center_icon">
            <img src="/static/imgs/address.svg" alt="address">
            <p>杭州办事处：中国浙江省杭州市上城区秋涛路28号凤凰中心1802</p>
          </div>
          <p class="footer_middle_center_title">深圳办事处：中国深圳市南山区高新科技园南一路TCL大厦B座9楼</p>
          <p class="footer_middle_center_title">香港办事处：香港轩尼诗道245-251号成功商业大厦A单元11楼A1单元邮编999077</p>
        </div>
        <div class="footer_middle_center" v-else>
          <h2>地址</h2>
          <div>
            <p>杭州办事处：</p>
            <p>中国浙江省杭州市上城区秋涛路28号凤凰中心1802</p>
          </div>
          <div>
            <p>深圳办事处：</p>
            <p>中国深圳市南山区高新科技园南一路TCL大厦B座9楼</p>
          </div>
          <div>
            <p>香港办事处：</p>
            <p>香港轩尼诗道245-251号成功商业大厦A单元11楼A1单元邮编999077</p>
          </div>
        </div>
      </div>
      <div class="footer_right">
        <div class="footer_line"></div>
        <p class="footer_right_title">关注或联系我们</p>
        <div class="footer_right_bottom">
          <div class="footer_right_bottom_left">
          <img src="/static/imgs/service.svg" alt="服务号">
          <p>服务号</p>
          </div>
          <div class="footer_right_bottom_right" >
          <img class="wxkf_img" src="/static/imgs/gongzhong.png" alt="微信客服">
          <p>微信客服</p>
          </div>
        </div>
        <p class="footer_right_middle1"><a href="tel:+8613429685631" >售后：+86-13429685631</a></p>
        <p class="footer_right_middle2"><a href="mailto:apps@myantdiy.com" >邮箱：apps@myantdiy.com</a></p>
        <div class="footer_right_time">（一般查询：周一至周日 9:00 至 18:00 EST）</div>
      </div>
    </div>
    <div class="footer_bottom">
      <p>一般查询：周一至周日 9:00 至 18:00 EST</p>
      <div>© 2023 ANTLINKS 版权所有 <a href="https://beian.miit.gov.cn/">浙ICP备19046082号</a></div>
    </div>

  </footer>
</template>

<script>
export default {
  name: 'FooterCN',
  data () {
    return {
      ispc:true
    }
  },
  methods: {
    golink(val){
      if(val=='home'){
        this.$router.push({
          path:'/cn/home'
        })
      }else if(val=='product'){
        this.$router.push({
          path:'/cn/products'
        })
      }else if(val=='help'){
        this.$router.push({
          path:'/help'
        })
      }
    }
  },
  created(){
    if(document.body.offsetWidth>767){
      this.ispc=true
    }else{
      this.ispc=false
    }
  }
}
</script>

<style scoped>
.wxkf_img{
  width: 120px;
  height: 120px;
  border-radius: 3px;
}
  .footer{
    width: 100%;
    background: #32404D;
  }
  .footer_top{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    padding: 100px 0 57px 0;
    justify-content: space-between;
    align-items: center;
  }
  .footer_line{
    display: none;
  }
  .footer_left_p{
    font-family: SourceHanSansCN-Bold;
    font-size: 24px;
    color: #FFFFFF;
    letter-spacing: 0.33px;
    font-weight: 700;
    margin: 35.5px 0 16px 0;
  }
  .footer_left_div{
    width: 310px;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0.22px;
    text-align: justify;
    line-height: 28px;
    font-weight: 400;
  }
  .footer_middle_top{
    display: flex;
    justify-content: space-between;
  }
  .footer_middle_top_span{
    font-family: SourceHanSansCN-Regular;
    font-size: 20px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 16px;
    font-weight: 400;
    cursor: pointer;
  }
  .footer_middle_top_div{
    width: 1px;
    height: 16px;
    background: #FFFFFF;
  }
  .footer_middle_center_icon{
    display: -webkit-box;
    margin-top: 66px;
  }
  .footer_middle_center_icon img{
    margin-right: 11px;
    margin-top: 3px;
  }
  .footer_middle_center p{
    width: 345px;
    font-family: SourceHanSansCN-Regular;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0.2px;
    line-height: 24px;
    font-weight: 400;
  }
  .footer_middle_center_title{
    margin:38px 0 0 29px
  }
  .footer_right_title{
    font-family: SourceHanSansCN-Medium;
    font-size: 20px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 16px;
    font-weight: 500;
    margin-top: 20px;
    margin-bottom: 63px;
  }
  .footer_right_middle1{
    margin:0 0 20px 0;
  }
  .footer_right_middle1 a{
    font-family: SourceHanSansCN-Medium;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 16px;
    font-weight: 500;
  }
  .footer_right_middle2{
    margin-bottom: 35px;
  }
  .footer_right_middle2 a{
    font-family: SourceHanSansCN-Medium;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 16px;
    font-weight: 500;
  }
  .footer_right_bottom{
    display: flex;
    margin-bottom: 35px;
  }
  .footer_right_bottom p{
    font-family: SourceHanSansCN-Medium;
    font-size: 18px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
    text-align: center;
    margin-top: 15px;
  }
  .footer_right_bottom_left{
    margin-right: 20px;
  }
  .footer_bottom{
    width: 100%;
    height: 109px;
    background: rgba(0,0,0,.1);
    padding: 30px 0 21px 0;
  }
  .footer_right_time{
    display: none;
  }
  .footer_bottom p{
    font-family: SourceHanSansCN-Medium;
    font-size: 16px;
    color: #8D919B;
    letter-spacing: 0;
    text-align: justify;
    font-weight: 500;
    margin-bottom: 18px;
    text-align: center;
  }
  .footer_bottom div{
    font-family: SourceHanSansCN-Medium;
    font-size: 16px;
    color: #8D919B;
    letter-spacing: 0;
    text-align: justify;
    line-height: 24px;
    font-weight: 500;
    text-align: center;
  }
  .footer_bottom a{
    color: #FF6032;
    cursor: pointer;
  }
  @media (max-width: 767px){
    .footer{
      width: 100%;
      background: #32404D;
    }
    .footer_top{
      width: 100%;
      margin: 0 auto;
      padding: .71rem .48rem .5rem .48rem;
      text-align: center;
      flex-direction: column;
    }
    .footer_left{
      order: 0;
    }
    .footer_middle{
      order: 3;
    }
    .footer_right{
      order: 2;
    }
    .footer_line{
      display: block;
      width: 6.54rem;
      height: .01rem;
      opacity: 0.2;
      border: .01rem solid rgba(151,151,151,1);
      margin: .6rem 0;
    }
    .footer_left img{
      width: 2.82rem;
      height: .78rem;
    }
    .footer_left_p{
      font-size: .32rem;
      letter-spacing: 0.0044rem;
      margin: .35rem 0 .37rem 0;
    }
    .footer_left_div{
      width: 100%;
      font-size: .24rem;
      letter-spacing: 0.005rem;
      line-height: .4rem;
    }
    .footer_middle_top{
      display: none;
    }
    .footer_middle_center h2{
      font-family: SourceHanSansCN-Bold;
      font-size: .24rem;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      font-weight: 700;
      margin-bottom: .19rem;
    }
    .footer_middle_center div{
      margin-bottom: .4rem;
    }
    .footer_middle_center p{
      width: 100%;
      opacity: 0.5;
      font-family: SourceHanSansCN-Medium;
      font-size: .24rem;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      line-height: .4rem;
      font-weight: 500;
    }
    .footer_right_title{
      font-size: .24rem;
      line-height: .24rem;
      margin-top: 0;
    }
    .footer_right_middle1{
      margin:.4rem 0 .3rem 0;
    }
    .footer_right_middle1 a{
      font-family: SourceHanSansCN-Bold;
      font-size: .42rem;
      line-height: .42rem;
    }
    .footer_right_middle2{
      margin-bottom: .605rem;
    }
     .footer_right_middle2 a{
      font-family: SourceHanSansCN-Bold;
      font-size: .42rem;
      line-height: .42rem;
    }
    .footer_right_bottom{
      display: flex;
      justify-content: center;
    }
    .footer_right_bottom img{
      width: 2.5rem;
      height: 2.5rem;
    }
    .footer_right_bottom p{
      font-size: .24rem;
      margin:.36rem 0 .24rem 0;
    }
    .footer_right_bottom_left{
      margin-right: .42rem;
    }
    .footer_right_time{
      display: block;
      opacity: 0.5;
      font-family: SourceHanSansCN-Medium;
      font-size: .24rem;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      font-weight: 500;
    }
    .footer_bottom{
      width: 100%;
      height: .8rem;
      background: rgba(0,0,0,.1);
      padding: .28rem 0;
    }
    .footer_bottom p{
      display: none;
    }
    .footer_bottom div{
      font-family: PingFangSC-Regular;
      font-size: .2rem;
      text-align: justify;
      line-height: .32rem;
      font-weight: 400;
      text-align: center;
    }
    .footer_bottom a{
      color: #FF6032;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/footerCN.vue